module.exports = __webpack_public_path__ + "static/logo-43862d96c06db263a064b9f623d38149.svg";